<template>
  <div class="employee_referral_system">
    <Special
    :isReverse="false"
    :image="require('../assets/employee_referral_system/title.png')"
    :imageSp="require('../assets/employee_referral_system/title_sp.png')"
    alt="社員紹介制度"
    mainCatch="社員紹介制度"
    subCatch="（リファラル採用）"
    intro="豆蔵は、技術者同士のご縁を大切にしており、<br class='over_display'>
    社員紹介制度を推進しています。<br>
    弊社の技術者との接点がある方は、<br class='over_display'>
    ぜひ、エントリーください。<br>
    選考をご希望の方だけではなく、<br class='over_display'>
    まずは話を聞きたい方のエントリーもお待ちしています。"
    />
    <ReferralArticle/>
    <div class="recruit_pitch">
			<iframe
				class="speakerdeck-iframe"
				frameborder="0"
				src="https://speakerdeck.com/player/517cdc8df49247819028052a3cc57149"
				title="株式会社豆蔵 会社紹介資料"
				allowfullscreen="true"
				mozallowfullscreen="true"
				webkitallowfullscreen="true"
				style="border: 0px; background: padding-box padding-box rgba(0, 0, 0, 0.1); margin: 0px; padding: 0px; border-radius: 6px; box-shadow: rgba(0, 0, 0, 0.2) 0px 5px 40px; width: 100%; height: 100%;"
				data-ratio="1.78343949044586"
			></iframe>
		</div>
  </div>
</template>
<script>
// @ is an alias to /src
import Special from '@/components/special/Special.vue';
import ReferralArticle from '@/components/special/ReferralArticle.vue';
export default {
  name: 'employee_referral_system',
    components: {
    Special,
    ReferralArticle,
  },
}
</script>

<style lang="scss" scoped>
.employee_referral_system {
  position: relative;
  width: 100%;
  overflow: hidden;
}
</style>
